export default function ActionBar({
    step,
    loading,
    publishing,
    onBack,
    onNext,
    onSave,
    onPreview,
    onPublish
}) {
    return (
        <div className="wg-action-bar">
            {step > 1 && (
                <button type="button" className="wg-btn secondary" onClick={onBack}>
                    Back
                </button>
            )}

            {step < 3 && (
                <button type="button" className="wg-btn primary" onClick={onNext}>
                    Next
                </button>
            )}

            {step === 3 && (
                <>
                    <button type="button" className="wg-btn primary" onClick={onSave} disabled={loading}>
                        {loading ? "Saving..." : "Save & Generate"}
                    </button>

                    <button type="button" className="wg-btn secondary" onClick={onPreview} disabled={loading}>
                        Preview
                    </button>

                    <button type="button" className="wg-btn success" onClick={onPublish} disabled={publishing}>
                        {publishing ? "Publishing..." : "Publish"}
                    </button>
                </>
            )}
        </div>
    );
}